export class ResilientWebSocket {
  constructor(options) {
    this.url = options.url;
    this.onMessage = options.onMessage;
    this.onStatus = options.onStatus;

    this.ws = null;
    this.retries = 0;
    this.baseDelay = 500;
    this.maxDelay = 10000;
    this.manualClose = false;

    this.connect();
  }

  connect() {
    if (this.onStatus) {
      this.onStatus("connecting");
    }

    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      this.retries = 0;
			console.log('WS connected')
      if (this.onStatus) {
        this.onStatus("connected");
      }
    };

    this.ws.onmessage = (e) => {
      this.onMessage(JSON.parse(e.data));
    };

    this.ws.onerror = () => {
      if (this.onStatus) {
        this.onStatus("error");
      }
      this.ws.close();
    };

    this.ws.onclose = () => {
      if (this.onStatus) {
        this.onStatus("disconnected");
      }
      if (!this.manualClose) {
        this.scheduleReconnect();
      }
    };
  }

  scheduleReconnect() {
    const delay = Math.min(
      this.baseDelay * Math.pow(2, this.retries++),
      this.maxDelay
    );

    setTimeout(() => this.connect(), delay);
  }

  send(payload) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(payload));
    }
  }

  close() {
    this.manualClose = true;
    if (this.ws) {
      this.ws.close();
    }
  }
}

